import { getProjectAsset } from '@/api/asset-controller/'
import { getTenantDevices } from '@/api/device-controller'
import { getTenantRelationEnergy, getTenantRelationInfo, getEnergyPList } from '@/api/relevance-relation-controller/' // getEnergyList

import assetIcon from '@/assets/icons/asset.png'
import deviceIcon from '@/assets/icons/device.png'

const cleanDeep = require('clean-deep')
/**
 * 获取asset数组和关系数组 过滤拼接得到一个 asset 关系树
 * @returns {Array}
*/

function searchInTree (tree, nodeId, cb) {
  for (const node of tree) {
    if (node.id.id === nodeId) {
      cb(node)
      return
    }
    if (node.children) {
      searchInTree(node.children, nodeId, cb)
    }
  }
}

export function getRelationTree (params) {
  let getListMethods = null
  let queryId = ''
  const methodsParams = params[0].toUpperCase()
  let getAdditionalInfo = false
  // let energyGetMethods = getTenantRelation
  switch (params[0]) {
    case 'asset':
      getListMethods = getProjectAsset
      queryId = params[1]
      console.log(params)
      break
    case 'energy':
      getListMethods = getEnergyPList
      queryId = params[1]
      console.log(queryId, '----queryId')
      break
    case 'quota':
    case 'indicator':
      getAdditionalInfo = true
      break
    default:
      break
  }
  const returnPromise = new Promise(function (reslove, reject) {
    let tenantAsset = []
    let tenantAssetRelation = []
    let resultTree = []

    if (getAdditionalInfo) {
      getTenantRelationInfo(methodsParams, params[1]).then(respons => {
        for (const item of respons.data) {
          resultTree.push(item)
        }
        reslove(resultTree)
      })
    } else {
      getListMethods(queryId).then(respons => {
        if (params[0] === 'asset') {
          tenantAsset = respons.data.data
          for (const item of tenantAsset) {
            item.allowAdd = true
            item.allowDelete = true
            item.icon = assetIcon
            item.assetId = item.id.id
            if (item.type === 'deviceDefine') {
              item.allowAddDevice = true
            }
          }
        }
        if (params[0] === 'energy') {
          tenantAsset = respons.data
          for (const item of tenantAsset) {
            item.allowAdd = true
            // item.allowDelete = true
            if (item.energyType !== 'energyAll') {
              item.allowDelete = true
            }
          }
        }

        getTenantRelationEnergy(methodsParams).then(respons => {
          // console.log(respons, '------关系')
          const relationFrom = []
          const relationTo = []
          const tenantAssetId = []
          const rootAsset = []

          tenantAssetRelation = respons.data
          tenantAsset.filter(item => {
            tenantAssetId.push(item.id.id)
          })
          tenantAssetRelation.filter(item => {
            relationFrom.push(item.from.id)
            relationTo.push(item.to.id)
          })
          // Find out root Id
          // Magic, don't touch
          tenantAssetId.forEach(item => {
            if (relationTo.includes(item)) {
              //
            } else {
              // 保存现在所在节点
              rootAsset.push(item)
              // rootAsset = item
              // 添加根节点
              resultTree.push(searchItem(tenantAsset, item))

              // 将排除了根节点的 assets 保存在 tenantAsset
              tenantAsset = tenantAsset.filter(item2 => {
                // return item2.id.id !== rootAsset
                return !rootAsset.includes(item2.id.id)
              })
              // resultTree[0].children = []
              for (const item of resultTree) {
                item.children = []
              }
            }
          })

          // resultTree[0].children = searchChildren(rootAsset)
          for (const item of resultTree) {
            item.children = searchChildren(item.id.id)
          }

          while (tenantAsset.length > 0) {
            search(resultTree)
          }

          // return resultTree
          // add allow delete && add for all node
          // 这里cleanDeep是抛掉所有undefined,空字符串等
          resultTree = cleanDeep(resultTree)
          // console.log(resultTree, '------dfsdfsdf')
          if (params[0] === 'asset') {
            getTenantDevices().then(resp => {
              const deviceList = resp.data.data
              const assetToDeviceRelation = tenantAssetRelation.filter(relation => {
                return relation.to.entityType === 'DEVICE'
              }).filter(relation => {
                return deviceList.find(device => {
                  return device.id.id === relation.to.id
                })
              })
              const deviceInRelation = deviceList.filter(device => {
                return assetToDeviceRelation.find(asset => {
                  return asset.to.id === device.id.id
                })
              })
              for (const relation of assetToDeviceRelation) {
                searchInTree(resultTree, relation.from.id, (node) => {
                  node.children = node.children || []
                  const deviceToAdd = deviceInRelation.find(device => {
                    return device.id.id === relation.to.id
                  })
                  node.children.push({
                    label: deviceToAdd.name,
                    allowDelete: true,
                    id: deviceToAdd.id,
                    parentAssetId: node.assetId,
                    icon: deviceIcon
                  })
                })
              }
              reslove(resultTree)
            })
          } else {
            reslove(resultTree)
          }
        })
      })
    }

    function searchItem (arrays, id) {
      const tempResult = arrays.filter(item => {
        item.children = [] // 增加children属性
        item.label = item.name
        return item.id.id === id
      })
      // 排除已经过滤的节点
      tenantAsset = tenantAsset.filter(item2 => item2.id.id !== id)
      return tempResult[0]
    }

    function searchChildren (rootId) {
      const childrens = []
      tenantAssetRelation.forEach(item => {
        if (item.from.id === rootId) {
          const itemchildren = searchItem(tenantAsset, item.to.id)
          childrens.push(itemchildren)
        }
      })
      return childrens
    }

    function search (left) {
      if (left && left.length > 0) {
      // if (left.length > 0) {
        left.forEach(item => {
          search(item)
        })
      } else if (left && left.children && left.children.length > 0) {
      // } else if (left.children && left.children.length > 0) {
        left.children.forEach(item => {
          search(item)
        })
      } else if (left) {
        const currentAssetId = left.id.id
        const tempChildren = searchChildren(currentAssetId)
        if (tempChildren[0] && tempChildren.length > 0) {
          left.children = tempChildren
        }
      }
      // } else {
      //   const currentAssetId = left.id.id
      //   const tempChildren = searchChildren(currentAssetId)
      //   if (tempChildren[0] && tempChildren.length > 0) {
      //     left.children = tempChildren
      //   }
      // }
    }
    // reslove(resultTree)
  })
  // return resultTree
  return returnPromise
}
